import React from "react";
import styles from "./DividerDefault.module.scss";

function DividerDefault({ children, lineColor = "#E2E8D5" }) {
  return (
    <div className={styles["divider"]} style={{ "--divider-line-color": lineColor }}>
      <div className={styles["divider__content"]}>{children}</div>
    </div>
  );
}

export default DividerDefault;
